import { Action, Reducer } from 'redux';
import { ACTION } from './action-types';
import * as actions from './action-types';
import { TargetState } from './types-store';
import { FieldItem } from '../../types';

export const INITIAL_STATE: TargetState = {
  fetching: false,
  initialized: false,
  defaultFields: [],
  additionalFields: []
};

export const targetReducers: { [indexer: string]: Reducer<TargetState, Action> } = {
  [ACTION.CLEAR_TARGET_STATE]: (state: TargetState,
    action: actions.ClearTargetState
  ): TargetState => {
    return {
      ...state,
      ...INITIAL_STATE
    };
  },
  [ACTION.REQUEST_TARGET_DEFAULT_FIELDS]: (state: TargetState,
    action: actions.RequestTargetDefaultFields
  ): TargetState => {
    return {
      ...state,
      fetching: true
    };
  },
  [ACTION.RESPONSE_TARGET_DEFAULT_FIELDS]: (state: TargetState,
    action: actions.ResponseTargetDefaultFields
  ): TargetState => {
    return {
      ...state,
      fetching: false,
      initialized: true,
      defaultFields: action.options as FieldItem[]
    };
  },
  [ACTION.UPDATE_DEFAULT_TARGET_FIELDS]: (state: TargetState,
    action: actions.UpdateTargetDefaultFields
  ): TargetState => {
    return {
      ...state,
      defaultFields: action.options as FieldItem[]
    };
  },
  [ACTION.RESPONSE_TARGET_FIELDS]: (state: TargetState,
    action: actions.ResponseTargetFields
  ): TargetState => {
    return {
      ...state,
      additionalFields: action.options as FieldItem[]
    };
  }
};

export const targetReducer = (state: TargetState = INITIAL_STATE, action: any) => {
  const r = targetReducers[action.type];
  return (r && r(state, action)) || state;
};
